export default __webpack_public_path__ + "media/images/buyer-image-74c148b039728163f4dec63942ffb555.png";